import React from 'react'
import SubHeader from '../../components/SubHeader'
import BlogCard from './BlogCard'
import GetQuote from '../../components/GetQuote'

export default function Blog({initialData}) {
    const subheadData = {
      image: '../assets/images/blog-banner.webp',
      pagename: 'Blogs',
      subhead: 'Insights, trends, and expertise from the world of commercial laundry solutions.',
    }

  return (
    <>
      <SubHeader subheadData={subheadData}/>
      <BlogCard initialData={initialData} />
      <GetQuote/>
    </>
  )
}
